/* Dazzuro — images des pastilles depuis la bibliothèque de textures.

   Trois choses tenaient les pastilles blanches un chargement sur deux :

   1. l image tiree etait celle du grand bloc « Detail sur la texture »
      (800px de large) pour une pastille de 24px. Vingt pastilles sur une
      grille de recommandations = vingt gros telechargements en concurrence.
      On lit desormais swatch_sm (160px), pose par sections/texture-library.

   2. la recherche dans la bibliotheque etait refaite pour CHAQUE pastille a
      CHAQUE mutation du DOM — et le DOM bouge beaucoup (recommandations en
      ajax, filtres, tiroir panier). Un index construit une seule fois et un
      marquage des pastilles deja traitees suppriment ce travail repete.

   3. la boucle d attente de window.TEXTURES abandonnait au bout de 6s sans
      jamais reessayer. Elle ecoute maintenant aussi le rechargement de
      section de l editeur de theme et le retour par l historique. */
(function () {
  'use strict';

  var ATTR = 'data-daz-texture-swatch';
  var ATTR_FAIT = 'data-daz-texture-applique';

  var frame = null;
  var libraryRetryTimer = null;
  var libraryRetryCount = 0;
  var index = null;
  var indexTaille = 0;

  function normaliser(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Le mot « cuir » est ignore pour comparer des noms de coloris : la fiche
     Amalfi dit « Blanc Cambon 11 Granada Cognac », la bibliotheque
     « Cambon 11 Cuir Granada Cognac » (meme regle que dazzuro-texture-card). */
  function sansCuir(s) {
    return (' ' + s + ' ').replace(/ cuir(?= )/g, '').replace(/\s+/g, ' ').trim();
  }

  function imageDe(item) {
    return item.swatch_sm || item.swatch || '';
  }

  /* Table « libelle normalise -> URL de pastille », construite une fois.
     Trois clefs par coloris : "Beige Abriamo 03", "Abriamo 03", "Beige".
     La premiere posee gagne : un nom complet est plus precis qu une couleur
     seule, et l ordre de la boucle reproduit celui de l ancienne recherche. */
  function construireIndex() {
    var textures = window.TEXTURES || [];
    var table = Object.create(null);
    var suffixes = [];

    for (var g = 0; g < textures.length; g += 1) {
      var items = (textures[g] || {}).items || [];

      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var image = imageDe(item);
        if (!image) continue;

        var nomComplet = [item.color, item.name].filter(Boolean).join(' ');
        var candidats = [nomComplet, item.name, item.color];

        for (var c = 0; c < candidats.length; c += 1) {
          var clef = sansCuir(normaliser(candidats[c]));
          if (clef && !table[clef]) table[clef] = image;
        }

        /* Certaines fiches nomment leur option « Velours Abriamo 03 » la ou la
           bibliotheque ne connait que « Abriamo 03 ». On garde donc les noms
           d article a part pour un rattrapage par suffixe. */
        var nomItem = sansCuir(normaliser(item.name));
        if (nomItem) suffixes.push({ suffixe: ' ' + nomItem, image: image });
      }
    }

    /* Le suffixe le PLUS LONG d abord : « Blanc Cambon 11 Granada Cognac » se
       termine aussi par « Granada Cognac » (le cuir seul), qui gagnait parce
       qu il venait plus tot dans la bibliotheque. Tri stable : a longueur
       egale, l ordre de la bibliotheque est conserve. */
    suffixes.sort(function (a, b) { return b.suffixe.length - a.suffixe.length; });

    indexTaille = textures.length;
    return { table: table, suffixes: suffixes };
  }

  function trouverImage(label) {
    var recherche = sansCuir(normaliser(label));
    if (!recherche || recherche.indexOf('texture personnalisee') !== -1) return '';

    var direct = index.table[recherche];
    if (direct) return direct;

    for (var i = 0; i < index.suffixes.length; i += 1) {
      var entree = index.suffixes[i];
      if (recherche.slice(-entree.suffixe.length) === entree.suffixe) return entree.image;
    }

    return '';
  }

  function appliquer() {
    var textures = window.TEXTURES;
    if (!textures || !textures.length) return;

    /* L editeur de theme peut recharger la bibliotheque : on rebatit l index
       si le nombre de groupes a change. */
    if (!index || indexTaille !== textures.length) index = construireIndex();

    var pastilles = document.querySelectorAll('[' + ATTR + ']');

    for (var i = 0; i < pastilles.length; i += 1) {
      var pastille = pastilles[i];
      var label = pastille.getAttribute(ATTR);

      /* Deja traitee pour CE libelle : rien a refaire. Le libelle fait partie
         du marqueur, une pastille dont l option change sera reevaluee. */
      if (pastille.getAttribute(ATTR_FAIT) === label) continue;

      var image = trouverImage(label);
      if (!image) continue;

      pastille.style.setProperty('--swatch-background-image', 'url("' + image.replace(/"/g, '\\"') + '")');
      pastille.classList.add('with-image');
      pastille.setAttribute(ATTR_FAIT, label);
    }
  }

  /* Une seule passe par frame, quel que soit le nombre de mutations. */
  function programmer() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      appliquer();
    });
  }

  function attendreBibliotheque() {
    if (window.TEXTURES && window.TEXTURES.length) {
      libraryRetryCount = 0;
      appliquer();
      return;
    }

    if (libraryRetryCount >= 100) return;
    libraryRetryCount += 1;
    clearTimeout(libraryRetryTimer);
    libraryRetryTimer = setTimeout(attendreBibliotheque, 100);
  }

  function initialiser() {
    attendreBibliotheque();

    var observer = new MutationObserver(programmer);
    observer.observe(document.body, { childList: true, subtree: true });

    /* Editeur de theme : la bibliotheque peut etre re-rendue apres coup. */
    document.addEventListener('shopify:section:load', function () {
      index = null;
      libraryRetryCount = 0;
      attendreBibliotheque();
    });

    /* Retour arriere depuis le cache du navigateur : le DOM est restaure tel
       quel, aucune mutation ne se produit. */
    window.addEventListener('pageshow', programmer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiser);
  } else {
    initialiser();
  }
})();
